// extracted by mini-css-extract-plugin
export default {"ImageUploader":"styles_ImageUploader__yT4Ig","info":"styles_info__ImoHz","uploadButton":"styles_uploadButton__ZFJjr"};